const NAME = "TYPES_OF_SKILLS_SPECIFIC_INDICATORS";

export default NAME;
